import {of as observableOf, Observable, ConnectableObservable} from 'rxjs';

import {publishReplay, distinctUntilChanged} from 'rxjs/operators';
import {EventEmitter, Input, OnInit, Output, Directive} from '@angular/core';
import {ResourceService} from '../../../resource/resource.service';
import {DatePipe} from '@angular/common';
import {Resource} from '../../../resource/resource';
import {CacheService} from '../../../cache/cache.service';
import {LanguageService} from '../../../language/language.service';
import {SmdDataTable} from './datatable.component';
import {EnvironmentConfigService} from '../../../core/services/environment-config.service';

let columnIds = 0;

@Directive()
export class SmdDataTableColumn implements OnInit {
  sortDir?: 'asc' | 'desc' = null;
  id: string = '' + ++columnIds;
  languageResource: Observable<string>;

  @Input() title: string;
  @Input() titleTooltip: string;
  @Input() field: string;
  @Input() numeric: boolean = false;
  @Input() sortable: boolean = false;
  @Input() detailLink: boolean = false;
  @Input() dataType: string;
  @Input() multiValued: boolean = false;

  get dataTypeCombined(): string {
    if (this.multiValued) return 'MultiValued';
    if (this.detailLink) return 'DetailLink';
    if (this.field === this.envConfig.getAttributeName('Timeline')) return 'Timeline';
    return this.dataType;
  }

  @Output() onFieldChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private dataTable: SmdDataTable,
    private resourceService: ResourceService,
    private datePipe: DatePipe,
    private cacheService: CacheService,
    private envConfig: EnvironmentConfigService,
  ) {
    this.languageResource = this.cacheService.getLanguageResource();
  }

  ngOnInit(): void {
    if (!this.title) {
      throw new Error('Title is mandatory on smd-datatable-column');
    }
    if (!this.field) {
      throw new Error('Field is mandatory on smd-datatable-column');
    }
  }

  getResource(model: any): Observable<Resource> {
    let obs = this.dataTable.observableCache[model[this.field]];
    if (obs == null && !(model[this.field] === null || model[this.field] === undefined)) {
      obs = this.resourceService
        .getBasicResource(model[this.field])
        .pipe(distinctUntilChanged(), publishReplay(1)) as ConnectableObservable<any>;
      this.dataTable.observableConnections.push(obs.connect());
      this.dataTable.observableCache[model[this.field]] = obs;
    }
    return obs;
  }

  getFirstResource(model: any): Observable<Resource> {
    if (!Array.isArray(model[this.field]) || model[this.field].length === 0) {
      return observableOf<Resource>(null);
    }

    let obs = this.dataTable.observableCache[model[this.field][0]];
    if (obs == null && !(model[this.field][0] === null || model[this.field][0] === undefined)) {
      obs = this.resourceService
        .getBasicResource(model[this.field][0])
        .pipe(distinctUntilChanged(), publishReplay(1)) as ConnectableObservable<any>;
      this.dataTable.observableConnections.push(obs.connect());
      this.dataTable.observableCache[model[this.field][0]] = obs;
    }
    return obs;
  }

  getFieldValue(model: any, languageResources: string, defaultValue?: any) {
    if (model == null) {
      console.error('SmdDataTableColumn: Model is null, cannot get cell value.');
      return '⚠';
    }
    let value = model[this.field];
    if (Array.isArray(value)) {
      return value.length;
    } else if (this.detailLink && model[this.field] == null) {
      return (
        '⟨ ' +
        LanguageService.translate('DatatableNo', 'No', languageResources) +
        ' ' +
        this.title +
        ' ⟩'
      );
    }
    if (value == null || value.length == 0) {
      return defaultValue;
    } else {
      return value;
    }
  }

  getFirstFieldValue(model: any, defaultValue?: any) {
    if (!Array.isArray(model[this.field]) || model[this.field].length === 0) return null;
    let value = model[this.field][0];
    if (Array.isArray(value)) {
      return value.length;
    }
    if (value == null || value.length == 0) {
      return defaultValue;
    } else {
      return value;
    }
  }
}
